import {RiFundsBoxLine, RiMoneyCnyBoxLine, RiHome8Line, RiSuitcaseLine} from 'react-icons/ri';
import {VscServerProcess} from 'react-icons/vsc';

export const stockMenu = [
    {
        title: "Stock Movers",
        path: "/stock/dashboard",
        icon: <RiFundsBoxLine />
    },
    {
        title: "Marketplace",
        path: "/stock/marketplace",
        icon: <RiMoneyCnyBoxLine />
    },
    {
        title: "My Portfolio",
        path: "/stock/portfolio",
        icon: <RiSuitcaseLine />
    },
    {
        title: "How It Works",
        path: "/stock/how-it-works",
        icon: <VscServerProcess />
    },
    {
        title: "Back To Home",
        path: "/",
        icon: <RiHome8Line />
    }
]
export const cryptoMenu = [
    {
        title: "Dashboard",
        path: "/crypto/dashboard",
        icon: <RiFundsBoxLine />
    },
    {
        title: "Crypto Curriences",
        path: "/crypto/currencies",
        icon: <RiFundsBoxLine />
    },
    {
        title: "How It Works",
        path: "/crypto/how-it-works",
        icon: <VscServerProcess />
    },
    {
        title: "Back To Home",
        path: "/",
        icon: <RiHome8Line />
    }
]